export const GLOBAL_CALENDAR_SHIFT_TYPES = {
	FLEX: 'FLEX',
	ON_DEMAND: 'ON_DEMAND',
	ALL: 'ALL'
};

export default GLOBAL_CALENDAR_SHIFT_TYPES;
